/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Tut_Apa_NInputs */

const en_mk_tut_apa_n = /** @type {(inputs: Mk_Tut_Apa_NInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`There is nothing to install on anybody’s computer. It all runs on the server; you just open the site in a browser or on your phone.`)
};

const id_mk_tut_apa_n = /** @type {(inputs: Mk_Tut_Apa_NInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tidak ada yang perlu dipasang di komputer siapa pun. Semua berjalan di server; Anda cukup membuka situsnya dari browser atau ponsel.`)
};

/**
* | output |
* | --- |
* | "There is nothing to install on anybody’s computer. It all runs on the server; you just open the site in a browser or on your phone." |
*
* @param {Mk_Tut_Apa_NInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_tut_apa_n = /** @type {((inputs?: Mk_Tut_Apa_NInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Tut_Apa_NInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_tut_apa_n(inputs)
	return en_mk_tut_apa_n(inputs)
});